<div class="delivery">
  <div class='back-to-dashboard' (click)="backToDashboard()" (keyup.enter)="backToDashboard()" (keydown.enter)="backToDashboard()">
    <mat-icon>arrow_back_ios</mat-icon>
    <span style='vertical-align:top;'>{{ 'checklist.backToPendingSummary' | translate}}</span>
  </div>
  <div class="container mt" id="service-container">
    <div class="row mb">
      <div class="col-md-12">
        <div class="breadcrumb-con">
          <div class="service-breadcrumb">
            <span class="breadcrumb-steps" *ngFor="let obj of breadcrumbSteps;"
              [class.activetab]="selectedIndex === (obj.id)">
              <span *ngIf="checkNav(obj.id); else elseBlock" class="step" (click)="switchTab(obj.id)">{{obj.name |
                translate}}</span>
              <ng-template #elseBlock><span class="step inactivetab">{{obj.name | translate}}</span></ng-template>
            </span>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-12">
        <mat-tab-group animationDuration="1000ms" [selectedIndex]="selectedIndex">
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-title">{{ 'testDrive.chooseVehicle' | translate}}</span>
              <span class="tab-hint">{{ 'testDrive.selectVehicle' | translate}}</span>
            </ng-template>
            <div class="service-content select-vehicle">
              <app-vehicle-customer-details (formEdited)="valuesChanges($event)" [isUpdate]="isUpdate"
               [digiChekId]="digiChekId" [vin]="vin" (enableSubmitButton)="enableButton($event)"></app-vehicle-customer-details>
            </div>

          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-title">{{ 'service.service' | translate}}</span>
              <span class="tab-hint">{{ 'service.selectService' | translate}}</span>
            </ng-template>
            <div class="service-content select-service">
              <app-digi-checklist #form2 [isUpdate]="isUpdate" (formEdited)="valuesChanges($event)" (doVinsMatch)="matchVins($event)">
              </app-digi-checklist>
            </div>
            <div [ngClass]="!doVinsMatch ? 'disable-component': ''">
              <div class="service-content select-service">
                <div class="header">{{'deliveryChecklist.productsOrServicesDueToCustomer' | translate}}</div>
                <div class="row">
                  <div class="box">
                    <p class="user-text">{{'deliveryChecklist.descriptionOfAnyProductsOrServicesDueToTheCustomer' | translate}}</p>
                  </div>
                  <mat-form-field class="no-fixed-height comment-width" appearance="outline">
                    <textarea matInput #DescriptionTextArea rows='5' [(ngModel)]="productsOrServicesDescription" (keydown.enter)="validateRowLimit($event)" (ngModelChange)="onDescriptionChange($event)" maxlength="250" placeholder="{{ 'delivery.placeHolderDescription' | translate}}"></textarea>
                    </mat-form-field>
                    <mat-hint class="hint">{{DescriptionTextArea.value?.length || 0}}/250 {{ 'delivery.characters' | translate}}</mat-hint>
                </div>
              </div>
            </div>
            <div [ngClass]="!doVinsMatch ? 'disable-component': ''">
              <div class="service-content select-service">
                <app-signatures #form3 [enableSig]="isValidDigiCheckForm()" [isUpdate]="isUpdate"
                  (formEdited)="valuesChanges($event)"></app-signatures>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
  <div class="service-sticky-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="sticky-breadcrumb">
            <div>
              <button (click)="gotoBack()"
                [ngClass]="selectedIndex !== 0 && !isSubmitting  && !isSaveForLaterSubmitting? 'btn-enable':''"
                class="goback-btn" [disabled]="selectedIndex === 0 || isSubmitting || isSaveForLaterSubmitting">{{
                'testDrive.back' | translate}}
              </button>
            </div>

            <div class="selection-info desktop spacer">
              <div class="footer-summaries">
                <ng-container *ngFor="let fs of digiChecklistFooterSummaries$ | async">
                  <ng-container>
                    <div class="footer-summary" *ngIf="fs.value">
                      <div class="key">
                        {{fs.key | translate}}
                        <span class="disclaimer" *ngIf="fs.disclaimer">*</span>
                      </div>
                      <div class="value">{{fs.value | translate}}</div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

            </div>

            <div class="spacer-mobile"></div>

            <div class="save-for-later-btn mr-3">
              <button (click)="onSubmitSaveForLater()" class="savelater-btn"
                [class.submitting]="isSaveForLaterSubmitting"
                [ngClass]="!isValidSaveForLaterForm() || isSaveForLaterSubmitting ? 'disable-btn' : 'btn-enable'"
                [disabled]="isSaveForLaterSubmitting">
                <ng-container *ngIf="isSaveForLaterSubmitting; else checklistSaveLabel">
                  <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate"
                    color="var(--dashboard-primary-color)" size=".7" [compact]="true"></app-loading>
                </ng-container>
                <ng-template #checklistSaveLabel>
                  <span>{{'delivery.saveForLater' | translate}}</span>
                </ng-template>
              </button>
            </div>
              <div class="continue-btn"
                [matTooltip]="((selectedIndex === 2) ? 'delivery.deliveryButtonDisabled':'') | translate"
                matTooltipClass="asp-custom-tooltip" matTooltipPosition="above">
                  <button (click)="switchTab()" class="continue" [class.submitting]="isSubmitting"
                    [ngClass]="!isValidForm() || (isSubmitting || isSaveForLaterSubmitting) || (selectedIndex===1 && !doVinsMatch) ? 'disable-btn' : 'btn-enable'"
                    [disabled]="isSubmitting || isSaveForLaterSubmitting">
                    <ng-container *ngIf="isSubmitting; else checklistContinueLabel">
                      <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="var(--dashboard-primary-color)" size=".7" [compact]="true">
                      </app-loading>
                    </ng-container>
                    <ng-template #checklistContinueLabel>
                      <span>{{continueBtnText[selectedIndex] | translate}}</span>
                    </ng-template>
                  </button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>